const TRAVEL_TIME_MINUTES = 10;
const OVERLAP_FACTOR = 0.3;
const ROUNDING_NUMBER = 10;

const roundToNearestRoundingNumber = (minutes: number): number => {
  return Math.round(minutes / ROUNDING_NUMBER) * ROUNDING_NUMBER;
};

export const calculateGroupDuration = (durations: number[]): number => {
  if (durations.length === 0) {
    return 0;
  }

  const maxDuration = Math.max(...durations);
  const otherDurationsSum =
    durations.reduce((sum, d) => sum + d, 0) - maxDuration;
  const estimatedMinutes =
    maxDuration + OVERLAP_FACTOR * otherDurationsSum + TRAVEL_TIME_MINUTES;

  return roundToNearestRoundingNumber(estimatedMinutes);
};
